import {useServices} from "../../../../../react-hooks/use-services.hook";
import {IGameContextViewModel} from "../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {FlexContainerBox} from "../../../../../themes/architecture/css-helpers/flex";
import {JackpotBarMagicBallComponent} from "../../../jackpot-bar-magic-ball/jackpot-bar-magic-ball.component";
import {GameFooterBarComponent} from "../../game-footer-bar.component";

interface DefaultGamePlayPcFooterBarComponentProps {
    gameContext: IGameContextViewModel;
}

export const DefaultGamePlayPcFooterBarComponent: React.FC<DefaultGamePlayPcFooterBarComponentProps> = (props) => {
    const services = useServices();
    const shouldRenderIGCMagic8Ball = () => {
        // If jackpot bet is enabled then the magic ball button will be rendered in game-jackpot-bar.component
        if (services.jackpotBet.isEnabled && props.gameContext.gameInfo.hasJackpotBet) {
            return false;
        }
        return services.magic8ball.shouldRenderBall;
    };

    const _renderTopSection = () => {
        return <FlexContainerBox alignItems='center' justifyContent='center'>
            <div style={{padding: "0.5rem"}}>
                <JackpotBarMagicBallComponent />
            </div>
        </FlexContainerBox>
    }

    if (!shouldRenderIGCMagic8Ball()) {
        return null;
    }

    return (
        <GameFooterBarComponent gameContext={props.gameContext} renderTopSection={_renderTopSection} />
    )
}